import * as React from 'react';

import styled from '@emotion/styled';
import { Alert, AlertProps } from '@lightspeed/flame/Alert';
import truncate from 'lodash/truncate';

export const AlertType = ['info', 'success', 'warning', 'danger'] as const;
export type AlertType = (typeof AlertType)[number];

export interface AlertMessageDTO {
  message: string | React.ReactElement;
  type: AlertType;
  title?: string;
}

interface Props extends AlertProps {
  alertMessage: AlertMessageDTO;
  noBorderTop?: boolean;
  truncateMessage?: boolean;
}

interface StyledAlertProps extends AlertProps {
  noBorderTop?: boolean;
}

const StyledAlert = styled(Alert)<StyledAlertProps>`
  ${(props) => props.noBorderTop && `border-top: inherit;`}
`;

const AlertMessageDisplay: React.FC<Props> = ({
  alertMessage,
  noBorderTop = false,
  truncateMessage = true,
  ...otherProps
}) => {
  const content =
    truncateMessage && typeof alertMessage.message === 'string'
      ? truncate(alertMessage.message, {
          length: 200,
          omission: '...',
          separator: ' ',
        })
      : alertMessage.message;

  return alertMessage ? (
    <StyledAlert
      title={alertMessage.title}
      type={alertMessage.type}
      noBorderTop={noBorderTop}
      data-test="alert-message-display"
      {...otherProps}
    >
      {content}
    </StyledAlert>
  ) : null;
};

export default AlertMessageDisplay;
